import axios from 'src/app-axios';
import Constants from 'src/constants';

export const featuresettings = {
    namespaced: true,
    state: {
        documentTypesList: [],
        selectedDocumentTypes: {},
        contractorCategoryList: [],
        questionnaireList: [],
        },
    getters: {
        getDocumentTypesList (state) {
        return state.documentTypesList;
      },
      getSelectedDocumentTypes (state) {
        return state.selectedDocumentTypes;
      },
      getContractorCategoryList (state) {
        return state.contractorCategoryList;
      },
      getQuestionnaireList (state) {
        return state.questionnaireList;
      },
    },
    mutations: {
      setDocumentTypesList (state, data) {
        state.documentTypesList = data;
      },
      setSelectedDocumentTypes  (state, data) {
        state.selectedDocumentTypes = data;
      },
      setContractorCategoryList (state, data) {
        state.contractorCategoryList = data;
      },
      setAllQuestionnaireList (state, data) {
        state.questionnaireList = data;
      },
      clearSavedDocumentTypes (state) {
        state.selectedDocumentTypes = [];
      },
    },
    actions: {
      async createContractorCategory ({ dispatch }, payload) {
        const url = 'api/contractor-category';
        try {
          await axios.post(url, payload);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in creating contractor this category.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchDocumentTypes ({ dispatch, commit }) {
        const url = 'api/document-types';
        try {
            const response = await axios.get(url);
              commit('setDocumentTypesList', response.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in getting document types.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
      },
      async createDocumentType ({ dispatch }, payload) {
        const url = 'api/document-types';
        try {
          await axios.post(url, payload);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in creating document type.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
          }
      },
      async fetchContractorCategoryList ({ dispatch, commit }) {
        const url = 'api/contractor-category';
        try {
            const response = await axios.get(url);
              commit('setContractorCategoryList', response.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in getting contractor category list.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
      },
      async createQuestionnaire ({ dispatch }, payload) {
        const url = 'api/questionnaire';
        try {
          await axios.post(url, payload.questionnaire);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in creating your questionnaire.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
          }
      },
      async fetchAllQuestionnaire ({ dispatch, commit }) {
        const url = 'api/questionnaire';
        try {
            const response = await axios.get(url);
              commit('setAllQuestionnaireList', response.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in getting contractor category list.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
      },
      async saveSelectedDocTypes  ({ commit }, payload) {
        commit('setSelectedDocumentTypes', payload.selectedDocumentType);
      },
      clearSavedDocumentTypes ({ commit }) {
        commit('clearSavedDocumentTypes');
      },
      async removeQuestionnaire ({ dispatch }, payload) {
        const url = `api/questionnaire/${payload.QuestionnaireId}`;
        try {
            await axios.delete(url);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in removing banner from campaign.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
    },
    },
};
